import { connect } from "react-redux";

import { userSelectsPrimaryFilterType, userSelectsPrimaryOptions } from "../actions/primary_filter";
import PrimaryFilter from "../components/primary_filter";

const mapStateToProps = (state) => {
  let f = state.filters;
  return {
    selectedTypeId: f.primaryFilter.selectedTypeId,
    selectedOptions: f.primaryFilter.selectedOptions,
    selectedViewTypeId: (f.viewType || {}).id
  };
};

const mapDispatchToProps = dispatch => ({
  onTypeChange: (e) => { dispatch(userSelectsPrimaryFilterType(e)); },
  onOptionsChange: (e) => { dispatch(userSelectsPrimaryOptions(e)); }
});

export default connect(mapStateToProps, mapDispatchToProps)(PrimaryFilter);
